/**
 * Created by huzhongchun on 2018/4/26.
 */

//project_label
export const PROJECT_LABEL = 'CHICKEN';

//route base path
export const PRODUCT_ROUTE_BASE_PATH = '/chicken/page/react';
export const DEVELOPMENT_ROUTE_BASE_PATH = '';

//api host
export const API_ONLINE_HOST = window.location.protocol+'//api.thefair.net.cn';
//get token
export const GET_TOKEN_URL = '/chicken/page/get_react_token';
export const GET_TOKEN_REQUEST_BASEURL = window.location.origin;
export const GET_TOKEN_REQUEST_TYPE = 'chicken';

function getRouteBaseUrl () {
	if(process.env.NODE_ENV === 'development'){
		return DEVELOPMENT_ROUTE_BASE_PATH;
	}else{
		return PRODUCT_ROUTE_BASE_PATH;
	}
}


export let defaultShareInfo = {
	wechat_session: {
		title: '新世相读书会，一年365本书，为你读书，伴你成长',
		text: '我们延揽大牛为你暴力拆解好书，提炼不掺水干货，将几十万字内容的精要，压缩在20分钟音频里。听这些就够了。',
		image: {
			url: 'http://resource.thefair.net.cn/_assets/touch/chicken/public/image/share_img_new.png'
		},
		link: window.location.protocol+'//h5.thefair.net.cn/chicken/page/react',
	},
	wechat_timeline: {
		title: '新世相读书会，一年365本书，为你读书，伴你成长',
		text: '我们延揽大牛为你暴力拆解好书，提炼不掺水干货，将几十万字内容的精要，压缩在20分钟音频里。听这些就够了。',
		image: {
			url: 'http://resource.thefair.net.cn/_assets/touch/chicken/public/image/share_img_new.png'
		},
		link: window.location.protocol+'//h5.thefair.net.cn/chicken/page/react',
	}
};

export const tabBar = [
	{
		path: getRouteBaseUrl()+'/',
		root: true,
		text: '首页',
		icon:'',
		activeIcon:''
	},
	{
		path: getRouteBaseUrl()+'/user_center',
		text: '我的',
		icon:'',
		activeIcon:''
	},
];

export default {
	PRODUCT_ROUTE_BASE_PATH,
	DEVELOPMENT_ROUTE_BASE_PATH,
	API_ONLINE_HOST,
	GET_TOKEN_URL,
	defaultShareInfo
};



// WEBPACK FOOTER //
// ./src/config/configChicken.js